import { render } from "./phoneValid.vue?vue&type=template&id=1830f4af&scoped=true"
import script from "./phoneValid.vue?vue&type=script&lang=js"
export * from "./phoneValid.vue?vue&type=script&lang=js"

import "./phoneValid.vue?vue&type=style&index=0&id=1830f4af&lang=scss&scoped=true"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/registerPhoneValidPop/components/phoneValid.vue'],['render',render],['__scopeId',"data-v-1830f4af"],['__file',"phoneValid.vue"]])

export default __exports__